export default __webpack_public_path__ + "static/media/about-page-img.95dadaa7.jpg";